import React from 'react';
import './App.css';
import logo from './assets/logo.jpg'; // Path to the profile logo image
import icon from './assets/icon.png'; // Path to the icon image
// import scott from './assets/scott.png';
import scott2 from './assets/scott2.png';
import ippo from './assets/hajimoIppo.png';
// import mannu from './assets/mannu_bhakar.png';
import Hours from './assets/Hours.png';
import Tourist from './assets/tourist.png';
import floyd from './assets/floyd.png';
import Hotz from './assets/Hotz.png';

function App() {
  return (
    <div className="container">
      {/* Left Side: Profile Image and Text */}
      <div className="profile-section">
        <img src={logo} alt="Profile" className="circular-image" />
        <div className="profile-heading">
          <p className="image-text">Leetcode Profiles</p>
        </div>
        <div className="profile-paragraph">
          <p className="image-paragraph">
            Coders deserve to be famous just like actors <br/><span className="center-text">and singers :)</span>
          </p>
        </div>
      </div>

      {/* Container for Title and Cards */}
      <div className="card-container">
        <div className="title-with-icon">
          <div className="icon-placing">
            <img src={icon} alt="Icon" className="icon-placing" /> {/* Icon before the title */}
          </div>
          <h3 className="latest-videos-title">Latest Videos</h3>
        </div>

        {/* First Section: Two Cards */}
        <div className="section-scroll-container">
          <div className="card2">
            <img src={Hotz} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">George Hotz: The Hacker Who Broke Boundaries</h2>
              <p className="card-description">
              Explore how I Hacked Iphone and make Impossible possible. And become Prodigy
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/watch?v=j_qLFwTaFvU";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/watch?v=j_qLFwTaFvU";
                  }, 1000);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>

          <div className="card2">
            <img src={Tourist} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">Tourist Biography: The Unstoppable King of Coding</h2>
              <p className="card-description">
              A journey of becoming the best through dedicated practice and learning.
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/watch?v=o_Ahgu1-zj4";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/watch?v=o_Ahgu1-zj4";
                  }, 1000);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>
        </div>
        <div className="title-with-icon">
          <div className="icon-placing">
            <img src={icon} alt="Icon" className="icon-placing" /> {/* Icon before the title */}
          </div>
          <h3 className="latest-videos-title">Motivational Videos</h3>
        </div>
        {/* Second Section: Two Cards */}
        <div className="section-scroll-container">
          <div className="card2">
            <img src={ippo} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">I’ll Bleed for My Dreams Before I Quit!</h2>
              <p className="card-description">
                Check out my latest videos on motivation stories, legends, and more!
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/watch?v=eWEAAp91O4Q&t=2s";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/watch?v=eWEAAp91O4Q&t=2s";
                  }, 1500);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>

          <div className="card2">
            <img src={floyd} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">Floyd Mayweathers motivational life story</h2>
              <p className="card-description">
                Check out my latest videos on motivation stories, legends, and more!
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/watch?v=b_NR4556Ubw&t";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/watch?v=b_NR4556Ubw&t";
                  }, 1000);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>
        </div>
        <div className="title-with-icon">
          <div className="icon-placing">
            <img src={icon} alt="Icon" className="icon-placing" /> {/* Icon before the title */}
          </div>
          <h3 className="latest-videos-title">YouTube Accounts</h3>
        </div>
        {/* Third Section: Two Cards */}
        <div className="section-scroll-container">
          <div className="card2">
            <img src={scott2} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">Stories of LeetCode Legends</h2>
              <p className="card-description">
                A journey of becoming the best through dedicated practice and learning.
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/@leetcodeprofiless";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/@leetcodeprofiless";
                  }, 1000);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>

          <div className="card2">
            <img src={Hours} alt="YouTube" className="card-image" />
            <div className="card-content">
              <h2 className="card-title">Mastering the 10000 Hours Rule</h2>
              <p className="card-description">
                The incredible story of determination and success against all odds.
              </p>
              <button
                className="card-button"
                onClick={() => {
                  window.location.href = "vnd.youtube://www.youtube.com/@ItTakes1000Hours";
                  setTimeout(() => {
                    window.location.href = "https://www.youtube.com/@ItTakes1000Hours";
                  }, 1000);
                }}
              >
                Open YouTube
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
